import React from "react";
import logger from "../../utils/LoggerFrontend";
const classNames = require("classnames");

class CampaignCreatePlacementView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      url: props.url,
      name: props.name
    };
  }

  render() {
    logger.debug("CampaignCreatePlacementView:render", "render:", this.props);

    const activeStyle = classNames({
      channel_wrapper: true,
      "fade-in": true
      // "deactivated": this.props.isChecked === false,
    });

    return (
      <div className={activeStyle}>
        {this.state.url && (
          <div className="channel_logo">
            <img src={`//logo.clearbit.com/${this.state.url}`} />
          </div>
        )}

        <div className="description">
          <h4>{this.state.name}</h4>
        </div>
      </div>
    );
  }
}

export default CampaignCreatePlacementView;
